import { gql } from '@apollo/client';

const CANCEL_STUDY_MUTATION = gql`
  mutation cancelStudy($id: ID!) {
    cancelStudy(id: $id) {
      isSuccess
      message
    }
  }
`;

export default CANCEL_STUDY_MUTATION;
